import React from 'react';
import PropTypes from 'prop-types';

// Components
import Error from '../core/error';
import FlagMetadataButtons from './flag-metadata-buttons';
import FlagMetadataIssueForm from './flag-metadata-issue-form';
import FlagMetadataIssues from './flag-metadata-issues';
import Loading from '../core/loading';
import RecordDetails from '../core/record-details';

// Containers
import FlaggedMetadata from '../../containers/flagged-metadata';

// Styles
import './flag-metadata.scss';

function FlagMetadata({ blacklistKeys, componentProps, headerRenderer, keyOrder, whitelistKeys, searchData }) {
  const getRowDetailsProps = (flaggedMetadata) => ({
    blacklistKeys,
    className: 'flag-metadata--row-details',
    headerRenderer,
    keyOrder: keyOrder || 'moviesAndPrograms',
    searchData,
    whitelistKeys,
    onClick: (event, key) => recordOnClick(event, key, flaggedMetadata),
    ...componentProps,
  });

  const recordOnClick = (_event, key, { setIssueFormValue }) => {
    setIssueFormValue('fieldName', key);
  };

  return (
        <FlaggedMetadata>
            {flaggedMetadata => {
                const {
                    error,
                    fetching,
                    flaggedMetadataAddIssue,
                    flaggedMetadataDeleteIssue,
                    setIssueFormValues,
                } = flaggedMetadata;

              return (
                    <div className="flag-metadata">
                        <RecordDetails {...getRowDetailsProps(flaggedMetadata)} />
                        <div className="flag-metadata--issue-form">
                            <FlagMetadataIssueForm
                                flaggedMetadataAddIssue={flaggedMetadataAddIssue}
                                searchData={searchData}
                            />
                        </div>
                        <FlagMetadataIssues
                            flaggedMetadataDeleteIssue={flaggedMetadataDeleteIssue}
                            setIssueFormValues={setIssueFormValues}
                        />
                        <Error error={error} />
                        <FlagMetadataButtons flaggedMetadata={flaggedMetadata} searchData={searchData} />
                        <Loading loading={fetching} />
                    </div>
              );
            }}
        </FlaggedMetadata>
  );
}

export default FlagMetadata;

FlagMetadata.propTypes = {
    blacklistKeys: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
    componentProps: PropTypes.func,
    defaultExpandKeys: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.bool]),
    detailExpandIcon: PropTypes.string,
    detailStartRenderer: PropTypes.func,
    headerRenderer: PropTypes.func,
    keyOrder: PropTypes.string,
    keyRenderers: PropTypes.object,
    noDetailExpand: PropTypes.bool,
    noTitleFormatting: PropTypes.bool,
    searchData: PropTypes.array.isRequired,
    whitelistKeys: PropTypes.arrayOf(PropTypes.string),
};
